import * as mapboxgl from 'mapbox-gl';

export class MapView {
  constructor(className) {
    mapboxgl.accessToken = "pk.eyJ1Ijoic3dpbWl0IiwiYSI6ImNqY2c3NXZkYzFoa2QycXQ1eXl1Mnd6M3EifQ.qpRE7xC08AyZfxJ56LoN7w";

    this._app = new swim.HtmlAppView(document.querySelector(`.${className}`));
    this._map = new mapboxgl.Map({
      container: this._app.node,
      style: "mapbox://styles/swimit/cjs5h20wh0fyf1gocidkpmcvm",
      // center: {lng: 55.296249, lat:  25.276987},
      center: {lng: 55.426, lat:  25.210},
      // pitch: 45,
      zoom: 10,
    });
    this._map.addControl(new mapboxgl.NavigationControl(), "top-left")
    .getCanvasContainer().addEventListener("touchstart", function () {
      // prevent dragPan from interfering with touch scrolling
      this._map.dragPan.disable();
    });

    this._mapView = new swim.MapboxView(this._map);
    this._mapView.overlayCanvas();

    // Water Mark
    this._mapboxLogo = document.querySelector('.mapboxgl-ctrl-logo');
    this._mapboxAttrib = document.querySelector('.mapboxgl-ctrl-attrib');
    this.mapboxWaterMark();
  }

  get appView() {
    return this._app;
  }

  get map() {
    return this._map;
  }

  get view() {
    return this._mapView;
  }

  mapboxWaterMark() {
    window.addEventListener('resize', this.waterMarkCompact.bind(this));
    this.waterMarkCompact();
  }

  waterMarkCompact(){
    this._mapboxAttrib.classList.add('mapboxgl-compact');
    this._mapboxLogo.classList.add('mapboxgl-compact');
  }
}
